import { FormikField } from '@ahmdigital/ui';
import { isEmpty, isNil, map, toLower } from 'lodash/fp';
import { PRODUCT_TYPE } from '@ahmdigital/constants';
import { useDispatch, useSelector } from 'react-redux';
import { useFormikContext } from 'formik';
import React, { useEffect } from 'react';

import { TYPE_LABEL } from '../../../../ahm-constants/ui';
import ProductActions from '../../../../actions/product';
import ProductService from '../../../../models/product';
import selectLastViewedProductId from '../../../../selectors/select-last-viewed-product';
import uncapFpIterator from '../../../../../utils/uncap-fp-iterator';

type ProductTypeFieldProps = {
  handleChangeProductType: Function;
};

const { getProduct } = ProductService;

const mapWithKey = uncapFpIterator(map);

const defaultCoverTypes = mapWithKey(
  (type: string, key: string) => ({
    text: type,
    value: toLower(key),
  }),
  TYPE_LABEL,
);

const ProductTypeField = ({ handleChangeProductType }: ProductTypeFieldProps) => {
  const lastViewedProductId = useSelector(selectLastViewedProductId);
  const products = useSelector((state: any) => state.product.data);
  const dispatch = useDispatch();
  const hasLastViewedProduct = !isNil(lastViewedProductId);
  const lastViewedProduct = hasLastViewedProduct ? getProduct(products, lastViewedProductId) : null;
  const { setFieldValue } = useFormikContext();

  useEffect(() => {
    if (hasLastViewedProduct && isEmpty(lastViewedProduct)) {
      const action = ProductActions.load(lastViewedProductId);
      dispatch(action);
    }
  }, [dispatch, hasLastViewedProduct, lastViewedProduct, lastViewedProductId]);

  // The lastViewedProduct property on the customer state could contain a product id
  // if the customer has previously viewed the product details. If this is the case,
  // the type of this lastViewedProduct is used as the default product type
  useEffect(() => {
    if (!isEmpty(lastViewedProduct)) {
      const productType =
        lastViewedProduct.type === PRODUCT_TYPE.COMBINED ? PRODUCT_TYPE.PACKAGE : lastViewedProduct.type;
      setFieldValue('productType', productType);
      handleChangeProductType(productType);
    }
  }, [handleChangeProductType, lastViewedProduct, setFieldValue]);

  return (
    <FormikField
      inputVariant={['button', 'fullWidth']}
      label="Select your health cover type"
      name="productType"
      options={[{ text: 'Please select', value: '' }, ...defaultCoverTypes]}
      // @ts-expect-error - Automatic, Please fix when editing this file
      onChange={({ target: { value } }) => {
        setFieldValue('productType', value);
        handleChangeProductType(value);
      }}
      size="auto"
      type="dropdown"
    />
  );
};

export default ProductTypeField;
